import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Languages from './Languages';

// import Button from './Button';

import LinkedinLogo from '../assets/linkedin.svg';
import QR from '../assets/Q for Quantessence Red.svg';
import EuroclearLogo from '../assets/euroclearLogo.png';

const navItems = [
  { to: '/', labelKey: 'mobile_nav.mob_home' },
  { to: '/services', labelKey: 'mobile_nav.mob_services' },
  { to: '/illustrations', labelKey: 'mobile_nav.mob_supported_products' },
  { to: '/news', labelKey: 'mobile_nav.mob_news' },
  { to: '/about', labelKey: 'mobile_nav.mob_about_us' },
  { to: '/careers', labelKey: 'mobile_nav.mob_careers' },
  { to: '/contact', labelKey: 'buttons.contact_button' },
];

const MobileNavItems = ({ onItemClick }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <>
      <div className='flex items-center px-12'>
        <img src={QR} alt='QR' className='h-12' loading='lazy' />
      </div>
      <ul className='flex flex-col gap-6 px-12 py-6'>
        {navItems.map(({ to, labelKey }) => (
          <li key={to}>
            <Link
              to={to}
              className={`block text-base font-medium py-2 border-b-2 ${
                (pathname === '/' && to === '/') ||
                (to !== '/' && pathname.startsWith(to))
                  ? 'text-primary-blue border-primary-red'
                  : 'text-primary-blue'
              }`}
              onClick={() => onItemClick(to)}
            >
              {t(labelKey)}
            </Link>
          </li>
        ))}
        {/* <Button onClick={() => onItemClick('/contact')}>
          {t('buttons.contact_button')}
        </Button> */}
        <div className='flex justify-start gap-6'>
          {/* <a
            href='https://www.youtube.com/@quantessenceltd.3054'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src={YoutubeLogo} alt='Youtube' className='h-8 w-8' />
          </a> */}
          <a
            href='https://www.linkedin.com/company/quantessence-financial-ltd/'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={LinkedinLogo}
              alt='Linkedin'
              className='h-8 w-8'
              loading='lazy'
            />
          </a>
          <a
            href='https://www.euroclear.com/en.html'
            target='_blank'
            rel='noopener noreferrer'
          >
            <img
              src={EuroclearLogo}
              alt='Euroclear'
              className='w-10'
              loading='lazy'
            />
          </a>
        <Languages classList='text-primary-blue' align='left' mobileUpward />
        </div>
      </ul>
    </>
  );
};

export default MobileNavItems;
